<template>
  <LevellingPageShell title="Pay Equity" icon="mdi-scale-balance">
    <ReportContainer v-bind="$attrs" v-on="$listeners" />
  </LevellingPageShell>
</template>

<script>
// Pay Equity ToC page — page head + centred content around the ratio-reports
// view (ReportContainer). $attrs/$listeners forward qaActions + the
// openDocument/reloadDocument/sessionExpired emits to App.vue's router-view.
import LevellingPageShell from '@/components/levelling/LevellingPageShell.vue';
import ReportContainer from '@/components/jobArchitecture/ReportContainer.vue';

export default {
  name: 'PayEquityPage',
  components: { LevellingPageShell, ReportContainer },
  inheritAttrs: false,
};
</script>
